// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-steps[data-v-557e2b29]{width:100%;display:flex;justify-content:space-around;align-items:center;min-height:100px;background:#fff}@media (max-width:576px){.flow-steps[data-v-557e2b29]{flex-wrap:wrap}}", ""]);
// Exports
module.exports = exports;
